
import Typography from '@mui/material/Typography';


export const TextDrugCodeine = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

The combination of acetaminophen and codeine is used to relieve mild to moderate pain. 
Acetaminophen is in a class of medications called analgesics (pain relievers) and antipyretics (fever reducers). 
It works by changing the way the body senses pain and by cooling the body. Codeine belongs to a class of medications called opiate (narcotic) analgesics and 
to a class of medications called antitussives. When codeine is used to treat pain, it works by changing the way the brain and nervous system respond to pain. 
When codeine is used to reduce coughing, it works by decreasing the activity in the part of the brain that causes coughing.
<br /><br />


Sources: <br /><br />
https://medlineplus.gov/druginfo/meds/a601005.html

</Typography>

</div>

)
}